import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const paymentService = createApi({
  reducerPath: "paymentService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getPaymentService: builder.query<any, { id: string }>({
      query: ({ id, ...rest }: { id: string; limit: number; search: string; page: number }) => ({
        url: `/payment-services/${id}`,
        params: { ...rest, include: "properties" },
        method: "GET",
        headers: {
          PageName: "Payment Service",
        },
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success) {
          return rawData;
        }
      },
    }),
    getPaymentServiceSupported: builder.query<any, void>({
      query: () => ({
        url: `/payment-services/supported?include=properties`,
        method: "GET",
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success) {
          return rawData.data;
        }
      },
    }),
    getPaymentServiceSupportedTransactionFee: builder.query<any, void>({
      query: () => ({
        url: `/payment-services/supported?include=properties`,
        method: "GET",
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success) {
          return [
            {
              code: "All",
              name: "All",
            },
            ...rawData.data,
          ];
        }
      },
    }),
    createPaymentService: builder.mutation<any, any>({
      query: (body) => ({
        url: `/payment-services/${body.merchantId}`,
        body,
        method: "POST",
        headers: {
          PageName: "Payment Service",
        },
      }),
    }),
    updatePaymentService: builder.mutation<any, any>({
      query: ({ id, merchantId, ...rest }) => ({
        url: `/payment-services/${merchantId}/${id}`,
        body: rest,
        method: "PUT",
        headers: {
          PageName: "Payment Service",
        },
      }),
    }),
    getPaymentServiceDetail: builder.query<any, any>({
      query: (params) => ({
        url: `/payment-services/${params.merchantId}/${params.id}`,
        params,
        headers: {
          PageName: "Payment Service",
        },
        method: "GET",
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success) {
          return rawData.data;
        }
      },
    }),
    deletePaymentService: builder.mutation<any, any>({
      query: (params) => ({
        url: `/payment-services/${params.merchantId}/${params.id}`,
        params,
        method: "DELETE",
        headers: {
          PageName: "Payment Service",
        },
      }),
    }),
    createMerchantObd: builder.mutation<any, any>({
      query: (body) => ({
        url: `/payment-services/merchantObd/${body.merchantId}`,
        body,
        method: "POST",
        headers: {
          PageName: "Merchant Onboarding",
        },
      }),
    }),
    getEmbedAuthorizeCode: builder.mutation<any, any>({
      query: (params) => ({
        url: `/payment-services/${params.merchant_id}/${params.id}/embedAuth/${params.connected_account_id}`,
        headers: {
          PageName: "Embed Kyc AuthorizeCode",
        },
        method: "GET",
      }),
    }),
    updateMerchantObd: builder.mutation<any, any>({
      query: (body) => ({
        url: `/payment-services/merchantObd/${body.merchantId}`,
        body,
        method: "PUT",
        headers: {
          PageName: "Merchant Onboarding",
        },
      }),
    }),
    getPartnerSettingsPayout: builder.query<any, { partner_id?: number }>({
      query: (body) => ({
        url: `/partner-management/${body.partner_id}/partner-settings/payout`,
        method: "GET",
        headers: {
          PageName: "Payment Service",
        },
      }),
    }),
    updatePartnerSettingsPayout: builder.mutation<any, any>({
      query: (body) => ({
        url: `/partner-management/${body.partner_id}/partner-settings/payout`,
        body,
        method: "PUT",
        headers: {
          PageName: "Payment Service",
        },
      }),
    }),
  }),
});

export const {
  useGetPaymentServiceQuery,
  useLazyGetPaymentServiceQuery,
  useGetPaymentServiceSupportedQuery,
  useGetPaymentServiceSupportedTransactionFeeQuery,
  useCreatePaymentServiceMutation,
  useUpdatePaymentServiceMutation,
  useGetPaymentServiceDetailQuery,
  useDeletePaymentServiceMutation,
  useCreateMerchantObdMutation,
  useUpdateMerchantObdMutation,
  useGetEmbedAuthorizeCodeMutation,
  useLazyGetPartnerSettingsPayoutQuery,
  useUpdatePartnerSettingsPayoutMutation
} = paymentService;
